module.exports = __webpack_public_path__ + "assets/d66fda55b14eb886f14d504664e3b17b.mp3";